import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/insights', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href
const resourcesBaseUrl = new URL('/api/v1/resources', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href

const httpClient = createHttpClient(baseUrl)
const resourcesHttpClient = createHttpClient(resourcesBaseUrl)

const InsightsApi = {
  async getAllOfferInsights() {
    const url = '/admin/offers'
    return await httpClient.get(url)
  },

  async getSellerOfferInsights(sellerOfferId) {
    const url = `/offer/${sellerOfferId}`
    return await httpClient.get(url)
  },

  async getRevenueChart({ granularityColumn = 'datesByYearMonth' }) {
    const url = '/revenue-insights/revenue'
    const params = { granularityColumn }

    return await resourcesHttpClient.get(url, { params })
  },

  async getRpcByCategoryChart({ startDate = null, endDate = null, accountId = null, categoryName = null } = {}) {
    const url = '/revenue-insights/rpc'
    const params = {}

    if (startDate) {
      params.startDate = startDate
    }

    if (endDate) {
      params.endDate = endDate
    }

    if (accountId) {
      params.accountId = accountId
    }
    
    if (categoryName) {
      params.categoryName = categoryName
    }

    return await resourcesHttpClient.get(url, { params })
  }
}

export default InsightsApi
